/* global DetectUserAgent */
import React from "react";
import PropTypes from "prop-types";
import LazyLoadVendor from "react-lazyload";

const LazyLoad = ({ lazy, once, offset, children, overflow }) => {
  const loadNow = !lazy || DetectUserAgent.isPrerender();

  if (loadNow) {
    return children;
  }

  return (
    <LazyLoadVendor once={once} offset={offset} overflow={overflow}>
      {children}
    </LazyLoadVendor>
  );
};

LazyLoad.propTypes = {
  lazy: PropTypes.bool,
  once: PropTypes.bool,
  overflow: PropTypes.bool,
  offset: PropTypes.number,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

LazyLoad.defaultProps = {
  lazy: false,
  once: false,
  overflow: false,
  offset: 0,
};

export default LazyLoad;
